export const id = {
  signIn: 'Masuk',
  signOut: 'Keluar',
  register: 'Daftar',
  or: 'atau',
  noHaveAccount: 'Belum punya akun?',
  nik: 'NIK(KTP)',
  fullname: 'Nama Lengkap',
  position: 'Posisi',
  gender: 'Pilih Gender',
  phoneNumber: 'Nomor Telepon',
  email: 'Email',
  password: 'Kata Sandi',
  confirmPassword: 'Konfirmasi Kata Sandi',
  alreadyAccount: 'Sudah punya akun?',
  greeting: 'Semoga harimu menyenangkan',
  hello: 'Hai',
  moduleAvailable: 'Module Tersedia',
  moduleTotal: 'Total Modul',
  taskTotal: 'Total Task',
  historyOfModules: 'Riwayat Pengerjaan Modul',
  noHaveHistory: 'Belum ada riwayat',
  Home: 'Branda',
  User: 'User',
  dateOfBirth: 'Tanggal Lahir',
  selectLang: 'Pilih Bahasa',
  buttonLang: {
    confirm: 'Terapkan Bahasa',
    cancel: 'Tutup',
  },
  registerUser: {
    success: 'Berhasil melakukan register',
    desc: 'Menunggu admin untuk meverifikasi atau hubungi admin untuk verifikasi akun',
  },
}
